import React, { useState, useEffect } from "react";
import minusSvg from "../../assets/images/minus.svg";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import API from "../../services/api";
import { formatDate } from "../../utils/dateFormat";
import {
  SlDrawer,
  SlOption,
  SlSelect,
  SlButton,
  SlInput,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { Toast } from "../../shared/Toast";
import { langoptions, roles } from "../../utils/constants";
import Brands from './Brands';
function Accordion(props) {
  const languageOptions = {
    1: "Telugu",
    2: "Tamil",
    3: "Hindi",
    4: "Kannada",
    5: "Malayalam",
    6: "Marathi",
    7: "Bengali",
    8: "Gujarati",
    10: "Oria",
  };
  const [open, setOpen] = useState(false);
  const [showRemoveAlert, setShowRemoveAlert] = useState(false);
  const [removeClicked, setRemoveClicked] = useState(false);
  const [sales, setSales] = useState();
  const [editAssignedSales, setEditAssignedSales] = useState(false);
  const [assignedDetails, setAssignedDetails] = useState();
  const [salesOptions, setSalesOptions] = useState([]);
  const [flag, setFlag] = useState("")
  
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const form1 = useForm();
  const removeSales = async()=>{
    try {
      let res = await API({
        url:'/birdview/unAssignBrandSales',
        method:"POST",
        responseType:'json',
        data:{
          brand_id: props.brand.brand_id,
          sales_id: sales.sales_id,
          // lang_id : sales.lang_id
        }
      })
      if(res.code === 200){
        props.loadData(0)
        setRemoveClicked(false)
        setShowRemoveAlert(false)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const onSubmit = async (data) => {
    try {
      let res = await API({
        url: '/birdview/editAssignBrandSales',
        method: 'POST',
        responseType: 'json',
        data: {
          sales_id: data.sales_id.value,
          brand_id: assignedDetails.brand_id,
          // lang_id: data.lang_id.value,
          incentive_rules: data.incentive_rules === '' ? assignedDetails.incentives_rules : data.incentive_rules,
          target: data.target === '' ? assignedDetails.target : data.target
        }
      })
      if (res.code === 200) {
        Toast('success', "Assigned Brand edited Sucessfully")
        setEditAssignedSales(false)
        setAssignedDetails()
        setFlag("")
      }
      else if (res.data.code === 400) {
        Toast('error', res.data.message)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchSales = async () => {
    if (flag === "edit") {
    try {
      let res = await API({
        url: '/reports/allsalespersons',
        method: 'POST',
        responseType: 'json',
        data: {}
      })
      if (res.code === 200) {
        setSalesOptions(res.data)
         form1.setValue('sales_id', res.data.find(option => option.value === assignedDetails.sales_id));
      }
    } catch (error) {
      console.error(error)
    }
  }
  }
  useEffect(() => {
    fetchSales()
  }, [flag]);

  return (
    <>
      <div className="d-flex justify-between">
        {props.data[0].assigned_to ? (
          <>
            <div className="w-[94%]" >
                <div className="d-flex gap-4">
                    <p className="my-0 text-xs font-medium capitalize">{props.data[0].assigned_to}</p>
                    {localStorage.getItem('role') === roles.b2b ? <sl-tooltip content="Remove Sales person">
                  <img src={minusSvg} alt="remove" className="w-3 h-3 cursor-pointer" onClick={() => { setShowRemoveAlert(true); setSales({ name: props.data[0].assigned_to, sales_id: props.data[0].sales_person_id, lang_id: props.data[0]?.lang_id, target: props.data[0].target, incentives_rules: props.data[0].incentives_rules }) }} />
                </sl-tooltip> : null}
                {/* <sl-tooltip content="Edit Assigned Sales">
                  <sl-icon-button
                    library="lucide"
                    name="edit"
                    onClick={() => {
                      setEditAssignedSales(true);
                      setFlag("edit");
                      setAssignedDetails({ name: props.data[0].assigned_to, sales_id: props.data[0].sales_person_id, lang_id: props.data[0]?.lang_id, target: props.data[0].target, incentives_rules: props.data[0].incentives_rules, brand_id: props.brand.brand_id });

                    }}
                  ></sl-icon-button>
                </sl-tooltip> */}
                </div>
              <p className="my-0 text-xs text-gray-400 d-flex justify-between">
                {/* <span className="d-flex gap-1 items-center"><SlIcon library="lucide" name="globe"></SlIcon>{languageOptions[props.data[0]?.lang_id]}</span> */}
                <span className="d-flex gap-1 items-center"><SlIcon library="lucide" name="calendar"></SlIcon>{formatDate(props.data[0].assigned_date)}</span>
                <span className="d-flex gap-1 items-center"><SlIcon library="lucide" name="user"></SlIcon>{props.data[0].assigned_by}</span>

              </p>
            </div>
            <div>
              {!open ? (
                <SlIcon
                  library="lucide"
                  name="chevron-down"
                  className="text-black hover:cursor-pointer"
                  onClick={() => setOpen(true)}
                ></SlIcon>
              ) : (
                <SlIcon
                  library="lucide"
                  name="chevron-up"
                  className="text-black hover:cursor-pointer"
                  onClick={() => setOpen(false)}
                ></SlIcon>
              )}
            </div>
          </>
        ) : (
          "-"
        )}
      </div>
      {open &&
        props.data?.slice(1)?.map((sales_person) => {
          return (
            <div className="mt-2">
               <div className="d-flex gap-4">
                    <p className="my-0 text-xs font-medium capitalize">{sales_person.assigned_to}</p>
                    <sl-tooltip content="Remove Sales person">
                  <img src={minusSvg} alt="remove" className="w-3 h-3 cursor-pointer" onClick={() => { setShowRemoveAlert(true); setSales({ name: sales_person.assigned_to, sales_id: sales_person.sales_person_id, lang_id: sales_person?.lang_id, target: props.sales_person.target, incentives_rules: props.sales_person.incentives_rules }) }} />
                </sl-tooltip>
                {/* <sl-tooltip content="Edit Assigned Sales">
                  <sl-icon-button
                    library="lucide"
                    name="edit"
                    onClick={() => {
                      setEditAssignedSales(true);
                      setFlag("edit");
                      setAssignedDetails({ name: sales_person.assigned_to, sales_id: sales_person.sales_person_id, lang_id: sales_person?.lang_id, target: sales_person.target, incentives_rules: sales_person.incentives_rules, brand_id: props.brand.brand_id });

                    }}
                  />
                </sl-tooltip> */}
                </div>
              <p className="my-0 text-xs text-gray-400  d-flex justify-between w-[96%]">
                <span className="d-flex gap-1 items-center"><SlIcon library="lucide" name="globe"></SlIcon>{languageOptions[sales_person?.lang_id]}</span>
                <span className="d-flex gap-1 items-center"><SlIcon library="lucide" name="calendar"></SlIcon>{formatDate(sales_person.assigned_date)}</span>
                <span className="d-flex gap-1 items-center"><SlIcon library="lucide" name="user"></SlIcon>{sales_person.assigned_by}</span>
              </p>
            </div>
          );
        })}
    <div>
        <Modal
          show={showRemoveAlert}
          onHide={() => {
            setShowRemoveAlert(false);
          }}
          backdrop="static"
          animation={false}
          dialogClassName="modal-30w"
          centered
        >
          <ModalHeader closeButton>
            <ModalTitle>
              <h3>Are you Sure ?(Remove Sales Person)</h3>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>
              <div>
                <p className="my-1 capitalize">{`Brand: ${props.brand.brand_name}`}</p>
                <p className="capitalize">{`Sales person: ${sales?.name}`}</p>
              </div>
              
              <div className="d-flex gap-3 justify-content-end mt-3">
                <button
                  className="btn btn-primary btn-sm"
                  type="button"
                  onClick={() => {
                    setShowRemoveAlert(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  type="submit"
                  onClick={() => {
                    removeSales()
                    setRemoveClicked(true);
                  }}
                  disabled={removeClicked}
                >
                  {removeClicked && (
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {removeClicked ? "Removing..." : "Remove"}
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <div>
        <SlDrawer
          label="Edit Assigned Brand"
          open={editAssignedSales}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setEditAssignedSales(false);
            setAssignedDetails()
            setFlag("")
          }}
          style={{ "--size": `${window.innerWidth <= 767 ? '100%' : '30vw'}` }}
        >
          <div>
            <form onSubmit={form1.handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label className="form-label">Select Sales Person</label>
                <Controller
                  name="sales_id" // Name of the form field
                  isDisabled={true}
                  control={form1.control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      name="sales"
                      placeholder={"Select Sales"}
                      options={salesOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      isDisabled={true}
                    />
                  )}
                />
                {
                  form1.formState.errors.sales_id && <p className="text-red-600">Sales Person is Required!</p>
                }
              </div>
              {/* <div className="mb-3">
                <label className="form-label">Select Language</label>
                <Controller
                  name="lang_id" // Name of the form field
                  disabled={flag === "edit" ? true : false}
                  control={form1.control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      name="language"
                      placeholder={"Select Language"}
                      options={languageOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      isDisabled={true}
                    />
                  )}
                />
                {
                  form1.formState.errors.lang_id && <p className="text-red-600">Language is Required!</p>
                }
              </div> */}
              <div className="mb-3">
                <label className="form-label">Incentive Rules</label>
                <input className="form-control" type="text" placeholder="Enter incentive Rules" defaultValue={flag === "edit" ? assignedDetails.incentives_rules : ""} {...form1.register('incentive_rules', { required: false })}></input>
              </div>
              <div className="mb-3">
                <label className="form-label">Target per month</label>
                <input className="form-control" type="number" placeholder="Enter target without special characters" defaultValue={flag === "edit" ? assignedDetails.target : ""} {...form1.register('target', { required: false })}></input>
              </div>
              <div className="mb-3">
                <SlButton variant="primary" size="small" type="submit">
                  Assign
                </SlButton>
              </div>
            </form>
          </div>
        </SlDrawer>
      </div>
    </>
  );
}

export default Accordion;
